import { DEFAULT_LANGUAGE, type LanguageCode } from './types';

type ResolveInitialLanguageOptions = {
  storedPreference: LanguageCode | null;
  browserLanguages: readonly string[];
  supportedLocales: readonly LanguageCode[];
};

const getPrimarySubtag = (languageTag: string): string =>
  languageTag.split('-')[0].toLowerCase();

const matchBrowserLanguage = (
  browserLanguages: readonly string[],
  supportedLocales: readonly LanguageCode[]
): LanguageCode | null => {
  const supportedPrimarySubtags = supportedLocales.map((locale) => getPrimarySubtag(locale));

  for (const tag of browserLanguages) {
    const primarySubtag = getPrimarySubtag(tag);
    const matchIndex = supportedPrimarySubtags.indexOf(primarySubtag);
    if (matchIndex !== -1) {
      return supportedLocales[matchIndex];
    }
  }

  return null;
};

export const resolveInitialLanguage = ({
  storedPreference,
  browserLanguages,
  supportedLocales,
}: ResolveInitialLanguageOptions): LanguageCode => {
  if (storedPreference) {
    return storedPreference;
  }

  return matchBrowserLanguage(browserLanguages, supportedLocales) ?? DEFAULT_LANGUAGE;
};
